module.exports = __webpack_public_path__ + "img/header_logo-o.782ba6c1.svg";